import { Link } from "react-router-dom";
import BloqLogo from "@/components/BloqLogo";
import SocialLinks from "@/components/SocialLinks";

export default function MarketingFooter() {
  return (
    <footer
      className="mt-32"
      style={{ background: "#0e1416", color: "#dde6e8" }}
      data-testid="marketing-footer"
    >
      <div className="bloq-container py-20">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2">
            <BloqLogo size={28} white />
            <p className="mt-5 text-sm text-white/65 max-w-sm leading-relaxed">
              Bloq turns conversations into outcomes. Host meetings, capture follow-ups,
              and keep the work moving — without duct-taping five tools together.
            </p>
            <SocialLinks tone="dark" className="mt-6" />
            <p className="mt-6 text-xs text-white/40">© 2026 Bloq, Inc. All rights reserved.</p>
          </div>
          <FooterCol
            title="Product"
            links={[
              { to: "/features", label: "Features" },
              { to: "/pricing", label: "Pricing" },
              { to: "/roadmap", label: "Roadmap" },
              { to: "/fund-a-feature", label: "Fund a feature" },
              { to: "/invest", label: "Invest in Bloq" },
            ]}
          />
          <FooterCol
            title="Company"
            links={[
              { to: "/contact", label: "Contact" },
              { to: "/feedback", label: "Feedback" },
              { to: "/beta-disclaimer", label: "Beta Disclaimer" },
              { to: "/privacy", label: "Privacy" },
              { to: "/terms", label: "Terms" },
              { to: "/fund-a-feature-terms", label: "Fund a Feature terms" },
              { to: "/accessibility", label: "Accessibility" },
            ]}
          />
          <FooterCol
            title="Get started"
            links={[
              { to: "/beta-signup", label: "Join the beta" },
              { to: "/beta-disclaimer", label: "Create account" },
              { to: "/login", label: "Log in" },
              { to: "/app", label: "Open app" },
            ]}
          />
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <p className="text-xs uppercase tracking-[0.18em] text-white/45 mb-4">{title}</p>
      <ul className="flex flex-col gap-2.5">
        {links.map((l) => (
          <li key={l.to}>
            <Link to={l.to} className="text-sm text-white/80 hover:text-white transition-colors">
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
